













































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class'
import RegisterTimeModal from '@/components/modals/RegisterTimeModal.vue';
//import RegisterTimeAdminModal from '@/components/modals/RegisterTimeAdminModal.vue';
import AnimatedNumber from '@/components/AnimatedNumber.vue';
import Button from '@/components/Button.vue';
import http from '@/methods/http.ts';
import moment from 'moment';

@Component({
    components: {
        RegisterTimeModal,
        //RegisterTimeAdminModal,
        AnimatedNumber,
        Button
    }
})
export default class ScheduleAdmin extends Vue {

    @Prop() slug;
    @Prop() specialist;
    @Prop(String) startDate
    @Prop() services
    @Prop() admin
    @Prop() current_org

    // @State('orderForm') orderForm: any;
    // @State('timeForm') timeForm: any;
    // @State('printForm') printForm: any;
    // @State('bufferForm') bufferForm: any;
    @State('copyBuffer') copyBuffer
    @State('cutBuffer') cutBuffer

    // @Mutation('changeOrderForm') changeOrderForm: void
    // @Mutation('changeTimeForm') changeTimeForm: void
    // @Mutation('changePrintForm') changePrintForm: void
    // @Mutation('changeBufferForm') changeBufferForm: void
    @Mutation('changeCopyBuffer') changeCopyBuffer
    @Mutation('changeCutBuffer') changeCutBuffer

    moment = moment;

    todayDay = moment().format('DD.MM.YYYY');
    timestamp = moment().subtract(1, 'days').endOf('day').unix();

    startTime = '';
    endTime = '';

    // cutBuffer = false;
    // copyBuffer = false;
    
    newday = '';
    newperiod = '';
    newperiods = [];

    confirmCanseled = false;
    orderForm = false;
    timeForm = false;
    printForm = false;
    bufferForm = false;
    confirmCanseledData = {
        'id': '',
        'service': '',
        'client_name': '',
        'comment': ''
    };
    orderData = {
        'id': '',
        'client_name': '',
        'phone': '',
        'comment': '',
        'price': ''
    };
    orderTimeData = {
        'id': '',
        'service': '',
        'client_name': '',
        'date_time_reservation': '',
        'duration': '',
    };
    printData = {
        'id': '',
        'service': '',
        'price': '',
        'client_name': '',
        'date_time_reservation': '',
        'time_reservation': '',
        'master_name': '',
    };
    bufferData = {};
    ordersFillData = [];

    @Watch('startDate', {deep: true, immediate: true})
    @Watch('specialist', {deep: true, immediate: true})
    onStartDateChange() {
        this.getSchedule();
        this.getSpecOrders();
    }

    colors = [
        '#2F80ED',
        '#F2C94C',
        '#ddd',
        '#eee',
    ];

    zcolors = [];
    schedule = [];
    orders = [];
    chosenCompany: any = {times: '00:00 - 23:59', periods: []};
    chosenService: any = {duration: '00:30:00'};
    chosenDay: string = '';

    datestamp(date) {
        return moment(date, 'DD.MM.YYYY').unix();
    }

    get periods() {
        if (!this.chosenCompany || !this.chosenService.name || !this.chosenDay.length) return [];
        
        const start: string = this.chosenCompany.times.split(' - ')[0];
        const globEnd: string = this.chosenCompany.times.split(' - ')[1];
        const sect: string = this.chosenService.duration;
        const orders: any[] = this.sortedByDayOrders[this.chosenDay];
        const lunch: any = this.chosenCompany.periods.find(i => i.p_type === 'lunch');
        const live: any = this.chosenCompany.periods.find(i => i.p_type === 'live');
        const rest_time: any[] = this.chosenCompany.periods.find(i => i.p_type === 'rest_time');

        let redtime = [];
        this.chosenCompany.periods.map((i) => {
            if (i.p_type === 'rest_time') {
                redtime.push(i);
            }
        });

        const chosenDay: string = this.chosenDay;

        //const lunch_and_rest_time = {...lunch, ...rest_time};
        return this.reorderSchedule(chosenDay, start, globEnd, sect, orders, lunch, redtime, live);

        //return this.workOnPeriods(start, globEnd, sect, orders, lunch_and_rest_time);
    }

    reorderSchedule(chosenDay, start, globEnd, sect, orders, lunch, rest_time, live) {
        let arr = [];
        let periods = [];

        if (lunch || (rest_time && rest_time.length > 0) || live) {
            if (live) {
                arr.push(live.start_time + '-' + live.end_time);
            }
            if (lunch) {
                arr.push(lunch.start_time + '-' + lunch.end_time);
            }
            if (rest_time.length > 0) {
                for (var k in rest_time) {
                    arr.push(rest_time[k].start_time + '-' + rest_time[k].end_time);
                }
            }
            arr.push(start + '-' + null);
            arr.push(null + '-' + globEnd);
        } else {
            arr.push(start + '-' + globEnd);
        }

        arr.sort();

        let arr2 = [];
        if (arr.length > 1) {
            for (var k in arr) {
                var next = k * 1 + 1;
                if (next >= arr.length) {
                    next = k;
                }
                var back = k * 1 - 1;
                if (back <= arr.length) {
                    back = k;
                }
                if ((arr[k]).split('-')[0] == 'null') {
                    // do nothing
                } else if ((arr[k]).split('-')[1] == 'null') {
                    arr2.push((arr[k]).split('-')[0] + '-' + (arr[next]).split('-')[0]);
                } else {
                    if ((arr[next]).split('-')[0] == 'null') {
                        arr2.push((arr[k]).split('-')[1] + '-' + (arr[next]).split('-')[1]);
                    } else {
                        arr2.push((arr[k]).split('-')[1] + '-' + (arr[next]).split('-')[0]);
                    }
                }
            }
        } else {
            arr2 = arr;
        }

        for(var k in arr2) {
            let orderArr: any[];
            if (orders && orders.length > 0) {
                let tempOrderArr = [];
                for(var z in orders) {
                    var st = ((arr2[k]).split('-')[0]).replace(':', '')*1;
                    var et = ((arr2[k]).split('-')[1]).replace(':', '')*1;
                    var idx = (orders[z].date_time_reservation.split(' ')[1]).replace(':', '')*1;
                    if (idx >= st && idx <= et) {
                        tempOrderArr.push(orders[z]);
                    }
                }
                if (tempOrderArr.length > 0) {
                    orderArr = tempOrderArr;
                }
            }
            periods = periods.concat(this.workOnPeriods((arr2[k]).split('-')[0], (arr2[k]).split('-')[1], sect, orderArr, {}, chosenDay));
        }
        return periods;
    }

    cancelTheReservation(id) {
        http(`reservation/${id}/cancel`, 'delete', this.$store.state.token, {}).then(r => {
                this.$store.commit('notificate', { type: 'action', text: 'Запись успешно удалена' });
                this.getSpecOrders();
            })
    }

    confirmTheReservation(id) {
        http(`reservation/${id}/edit`, 'put', this.$store.state.token, {
            status: {
                type: 'confirm'
            }
        }).then(r => {
            this.$store.commit('notificate', { type: 'action', text: 'Запись успешно принята' });
            this.getSpecOrders();
        })
    }

    selectNewPeriod(duration)
    {
        for (let key in this.schedule) {
            if (this.schedule[key].day === this.newday) {
                let start = this.schedule[key].periods[0].start_time;
                let globEnd = this.schedule[key].periods[this.schedule[key].periods.length - 1].end_time;
                let sect = duration;
                let orders = this.sortedByDayOrders[this.newday];
                let lunch = this.schedule[key].periods.find(i => i.p_type === 'lunch');
                let rest_time = this.schedule[key].periods.find(i => i.p_type === 'rest_time');

                const lunch_and_rest_time = {...lunch, ...rest_time};
                this.newperiods = this.workOnPeriods(start, globEnd, sect, orders, {});
            }
        }
    }

    copyPopup(data) {
        this.ordersFillData = [];
        this.bufferData = data;
        this.changeCopyBuffer(true);
        // this.copyBuffer = true;
        this.$parent.$parent.copyBuffer = true;
    }

    pasteBuffer(date_time_reservation, start, owner) {
        this.bufferData.date_time_reservation = date_time_reservation+' '+start;
        this.bufferData.master_name = owner;
        //this.bufferForm = true;
        this.saveBuffer();
    }

    saveBuffer() {
        this.bufferForm = false;
        if (this.copyBuffer === true) {
            this.changeCopyBuffer(false);
            //  this.copyBuffer = false;
            this.$parent.$parent.copyBuffer = false;
            let token = 'guest';
            http(`masters/${this.slug}/reservation/create`, 'post', token, {
                'user_id': this.bufferData.user_id,
                'service': this.bufferData.service,
                'price': this.bufferData.price,
                'master_name': this.bufferData.master_name,
                'client_name': this.bufferData.client_name,
                'reservation_time': this.bufferData.date_time_reservation,
                'phone': this.bufferData.phone,
                'comment': '',
                'duration': this.bufferData.duration,
                'street_address': this.bufferData.street_address,
                'status': 'confirmed'
            }).then(r => {
                this.bufferData = {};
                this.$store.commit('notificate', {type: 'action', text: 'Спасибо, данное время забронировано'});
                this.getSpecOrders();
            }).catch(error => {
                this.$store.commit('notificate', {text: error.response.data.message, type: 'error'});
            });
        }
        if (this.cutBuffer === true) {
            this.changeCutBuffer(false);
            //  this.cutBuffer = false;
            this.$parent.$parent.cutBuffer = false;
            http('reservation/update', 'post', this.$store.state.token, {
                id: this.bufferData.id,
                reservation_time: this.bufferData.date_time_reservation
            }).then(r => {
                if (r.data.success === true) {
                    this.bufferData = {};
                    this.$store.commit('notificate', { type: 'action', text: 'Запись обновлена' });
                    this.getSpecOrders();
                }
            }, error => {
                this.$store.commit('notificate', { type: 'alert', text: error.response.data.message });
            })
        }
    }

    printPopup(id, service, price, client_name, date_time_reservation, master_name)
    {
        moment.lang('ru');
        let time_reservation = moment(date_time_reservation, 'DD.MM.YYYY HH:mm').format('HH:mm');
        date_time_reservation = moment(date_time_reservation, 'DD.MM.YYYY HH:mm').format('DD MMMM YYYY');
        this.printData.service = service;
        this.printData.price = price;
        this.printData.client_name = client_name;
        this.printData.date_time_reservation = date_time_reservation;
        this.printData.time_reservation = time_reservation;
        this.printData.master_name = master_name;
        this.printForm = true;
    }

    PrintMe(elm) {
        var disp_setting="toolbar=yes,location=no,";
        disp_setting+="directories=yes,menubar=yes,";
        disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
        var content_vlue = document.getElementById(elm).innerHTML;
        var docprint=window.open("","",disp_setting);
        docprint.document.open();
        docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
        docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
        docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
        docprint.document.write('<head><title>My Title</title>');
        docprint.document.write('<style type="text/css">body{ margin:0px;');
        docprint.document.write('font-family:verdana,Arial;color:#000;');
        docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:12px;}');
        docprint.document.write('a{color:#000;text-decoration:none;} </style>');
        docprint.document.write('</head><body onLoad="self.print()"><center>');
        docprint.document.write(content_vlue);
        docprint.document.write('</center></body></html>');
        docprint.document.close();
        docprint.focus();
    }

    editTimePopup(data)
    {
        this.ordersFillData = [];
        this.bufferData = data;
        this.changeCutBuffer(true);
        // this.cutBuffer = true;
        this.$parent.$parent.cutBuffer = true;
    }

    editOrderPopup(id, client_name, phone, comment, price)
    {
        this.orderData.id = id;
        this.orderData.client_name = client_name;
        this.orderData.phone = phone;
        this.orderData.comment = comment;
        this.orderData.price = price;
        this.orderForm = true;
    }

    updateOrderTime(id) {
        if (this.newday === '') {
            this.$store.commit('notificate', { type: 'alert', text: 'new day is empty' });
            return false;
        }
        if (this.newperiod === '') {
            this.$store.commit('notificate', { type: 'alert', text: 'new period is empty' });
            return false;
        }
        http('reservation/update', 'post', this.$store.state.token, {
            id: id,
            reservation_time: this.newday+' '+this.newperiod
        }).then(r => {
            if (r.data.success === true) {
                this.timeForm = false;
                this.$store.commit('notificate', { type: 'action', text: 'Запись обновлена' });
                this.getSpecOrders();
            }
        }, error => {
            this.$store.commit('notificate', { type: 'alert', text: error.response.data.message });
        })
    }

    updateOrder() {
        http('reservation/update', 'post', this.$store.state.token, {
            id: this.orderData.id,
            client_name: this.orderData.client_name,
            phone: this.orderData.phone,
            comment: this.orderData.comment,
            price: this.orderData.price,
        }).then(r => {
            if (r.data.success === true) {
                this.orderForm = false;
                this.$store.commit('notificate', { type: 'action', text: 'Запись обновлена' });
                this.getSpecOrders();
            }
        }, error => {
            this.$store.commit('notificate', { type: 'alert', text: error.response.data.message });
        })
    }

    confirmCanseledPopup(id, service, client_name)
    {
        this.confirmCanseledData.id = id;
        this.confirmCanseledData.service = service;
        this.confirmCanseledData.client_name = client_name;
        this.confirmCanseledData.comment = '';
        this.confirmCanseled = true;
    }

    canceledOrder(id) {
        if (this.confirmCanseledData.comment === '') {
            this.$store.commit('notificate', { type: 'alert', text: 'Укажите причину отмены заявки' });
            return false;
        }
        this.updateStatus(id, 'refused');
    }

    updateStatus(id, status) {
        http('reservation/update', 'post', this.$store.state.token, {
            id: id,
            status: status,
            comment: this.confirmCanseledData.comment
        }).then(r => {
            if (r.data.success === true) {
                this.confirmCanseled = false;
                this.$store.commit('notificate', { type: 'action', text: 'Запись обновлена' });
                this.getSpecOrders();
            }
        }, error => {
            this.$store.commit('notificate', { type: 'alert', text: error.response.data.message });
        })
    }

    checkIfHasFreePeriods(times, orders, company) {

        const sect = this.services.length ? this.services[0].duration : '00:15:00';
        const start: string = times.split(' - ')[0];
        const globEnd: string = times.split(' - ')[1];
        const lunch = company.periods.find(i => i.p_type === 'lunch');
        const rest_time = company.periods.find(i => i.p_type === 'rest_time');

        const lunch_and_rest_time = {...lunch, ...rest_time};

        return this.workOnPeriods(start, globEnd, sect, orders, lunch_and_rest_time).length > 0;
    }

    checkIfInThisDuration(time, dur, start, end) {
        return moment(start, 'HH:mm').diff(moment(time.split(' ')[1], 'HH:mm')) <= 0 && moment(end, 'HH:mm').diff(moment(time.split(' ')[1], 'HH:mm')) >= 0;
    }

    reservationCreatedHandler() {
        this.getSpecOrders();
        this.specModal = false;
    }

    workOnPeriods(start, globEnd, sect, orders, lunch, chosenDay = '', filtered = false, scheduleDay) {
        console.log({ start, globEnd, sect, orders, lunch, chosenDay, filtered })
        if (filtered === true) {
            let tempOrderArr = [];
            for(var z in orders) {
                var st = start.replace(':', '')*1;
                var et = globEnd.replace(':', '')*1;
                var idx = (orders[z].date_time_reservation.split(' ')[1]).replace(':', '')*1;
                if (idx >= st && idx <= et) {
                    tempOrderArr.push(orders[z]);
                }
            }
            if (tempOrderArr.length > 0) {
                orders = tempOrderArr;
            }
        }

        let currentOrder = orders ? orders[0] : { date_time_reservation: '01.01.1970 23:59' };
        let current = start;
        let periods = [];

        let todayDay = moment().format('DD.MM.YYYY');
        let nowTime = moment().unix();
        let startTime = moment(start, 'HH:mm').unix();
        if (todayDay == chosenDay && startTime < nowTime) {
            let finish = moment();
            let remainder = 15 - (finish.minute() % 15);
            current = moment(finish).add(remainder, "minutes").format('HH:mm');
        }

        const self = this

        function generatePeriods() {
            startTime = moment(current, 'HH:mm').unix();
            if (todayDay == chosenDay && startTime < nowTime) {
                let finish = moment();
                let remainder = 15 - (finish.minute() % 15);
                current = moment(finish).add(remainder, "minutes").format('HH:mm');
            }

            let now = moment(current, 'HH:mm');
            let dur = moment.duration(sect);
            let end = now.add(dur);

            if (end.diff(moment(globEnd, 'HH:mm')) > 0) {
                return;
            }
            //if (lunch && (end.diff(moment(lunch.start_time, 'HH:mm:ss')) >= 0 && end.diff(moment(lunch.end_time, 'HH:mm:ss')) <= 0)) {
            if (lunch && (end.diff(moment(lunch.start_time, 'HH:mm')) > 0 && end.diff(moment(lunch.end_time, 'HH:mm')) <= 0)) {
                current = moment(lunch.end_time, 'HH:mm').format('HH:mm');
            } else if (end.diff(moment(currentOrder.date_time_reservation.split(' ')[1], 'HH:mm')) <= 0) {
                console.log({ schedule: self.schedule, scheduleDay, current, dateTime: moment(scheduleDay+' '+current, 'DD-MM-YYYY HH:mm').unix(), nowTime })
                if (!scheduleDay) {
                    periods.push({start: current, end: end.format('HH:mm')});
                } else {
                    if (moment(scheduleDay+' '+current, 'DD-MM-YYYY HH:mm').unix() >= nowTime) periods.push({start: current, end: end.format('HH:mm')});
                }
                
                // periods.push({start: current, end: end.format('HH:mm')})
                current = end.format('HH:mm');
            } else {
                current = moment(currentOrder.date_time_reservation.split(' ')[1], 'HH:mm').add(moment.duration(currentOrder.duration)).format('HH:mm');
                currentOrder = orders[orders.indexOf(currentOrder) + 1] ? orders[orders.indexOf(currentOrder) + 1] : { date_time_reservation: '01.01.1970 23:59' };
            }
            generatePeriods();
        }
        generatePeriods();
        return periods;
    }

    get sortedByDayOrders() {
        let orderedByDays = {};
        this.orders.map((i) => {
            let date = moment(i.date_time_reservation, 'DD.MM.YYYY hh:mm').format('DD.MM.YYYY');
            i.timestamp = moment(date, 'DD.MM.YYYY').unix();
            orderedByDays[date] ? orderedByDays[date].push(i) : orderedByDays[date] = [i];
        });
        return orderedByDays;
    }

    dateToUnix(date) {
        return moment(date, 'DD.MM.YYYY').unix();
    }

    fillOrders(date_time, start) {
        let idx = date_time+'-'+start;
        if (this.ordersFillData[idx]) {
            return false;
        } else {
            this.ordersFillData[idx] = true;
            return true;
        }
    }

    filteredOrders(date_time, owner) {
        let date = '';
        let filteredArr = [];
        this.orders.map((i) => {
            date = moment(i.date_time_reservation, 'DD.MM.YYYY hh:mm').format('DD.MM.YYYY');
            if (date === date_time && i.master_name === owner) {
                return {fff:'ggg'};
                filteredArr[date] ? filteredArr[date].push(i) : filteredArr[date] = [i];
            }
        });
        if (filteredArr[date]) {
            return filteredArr[date];
        } else {
            let filteredArr: any[];
            return filteredArr;
        }
    }

    getSchedule() {
        http(`masters/${this.slug}/schedule/beta`, 'get', false, {
            day: this.startDate,
            day_count: 7,
            orgs: this.current_org
        }).then(r => {
            this.schedule = r.data
        });
    }

    getSpecInfo() {
        http(`masters/${this.slug}`, "get", false, {}).then(r => {
            //this.specInfo = r.data;
            let owner_colors = [];
            let color_palette = this.colors;
            let i = 0;
            if (r.data.company) {
                r.data.company.forEach(function (element) {
                    owner_colors[element.owner] = color_palette[i];
                    i++;
                });
                this.zcolors = owner_colors;
            }
        });
    }

    getSpecOrders() {
        http(`masters/${this.slug}/reservations`, "get", false, {
            date_time_start: this.startDate,
            date_time_end: moment(this.startDate, 'DD.MM.YYYY').add(7, "d").format('DD.MM.YYYY'),
            sort: 'reservation_time_asc'
        }).then(r => {
            this.orders = r.data;
        })
    }

    formatTime(time) {
        return moment(time, 'HH:mm:ss').format('HH:mm');
    }

    formatDate(day) {
        return moment(day, 'DD.MM.YYYY').format('DD.MM.YYYY')
    }

    convertDayDate(d) {
        moment.locale('ru');
        let date = moment(d, 'DD.MM.YYYY');
        return [date.format('DD'), date.format('MMMM'), date.format('dd')];
    }

    divideToCompanies(periods) {
        let orgs = this.specialist.company;
        let companies = {};
        periods.map(i => companies[i.owner] ? companies[i.owner].push(i) : companies[i.owner] = [i]);

        let companiesArr = [];
        for (let key in companies) {
            let street_address = '';
            let workPers = [];
            orgs.map(i => {
                if (i.name === key) street_address = i.street_address;
            });
            companies[key].map(i => {
                if (i.p_type === 'work') workPers.push(i);
            });
            companiesArr.push({
                owner: key,
                street_address: street_address,
                periods: companies[key],
                times: `${this.formatTime(workPers[0].start_time)} - ${this.formatTime(workPers[workPers.length - 1].end_time)}`,
            })
        }
        companiesArr.map((i, index) => {
            i.color = this.colors[index] 
        });
        return companiesArr;
    }

    specModal = false;

    mounted() {
        this.getSchedule();
        this.getSpecOrders();

        window['moment'] = this.moment;

        this.getSpecInfo();
        /*
        let owner_colors = [];
        let color_palette = this.colors;
        let i = 0;
        if (this.specialist.company) {
            this.specialist.company.forEach(function (element) {
                owner_colors[element.owner] = color_palette[i];
                i++;
            });
            this.zcolors = owner_colors;
        }
        */
    }
}

